// Opens a WebSocket to the Gateway's /ws endpoint, bound to the gameID
// the signaling handshake assigned. The server pushes JSON messages
// (iteration 1.5+: ship_detail). No game-to-server messages are sent over
// this channel in iteration 1.x.

export function openGameSocket(gameID, onMessage) {
  const proto = window.location.protocol === 'https:' ? 'wss:' : 'ws:'
  const url = `${proto}//${window.location.host}/ws?gameID=${gameID}`
  const ws = new WebSocket(url)
  ws.addEventListener('message', (ev) => {
    if (typeof ev.data !== 'string') return
    try {
      const obj = JSON.parse(ev.data)
      onMessage(obj)
    } catch {
      // ignore malformed payloads
    }
  })
  return ws
}
